module.exports = __webpack_public_path__ + "static/img/partner-logo-2.23d147a6.png";